export { default as NCountdown, countdownProps } from './src/Countdown';
